<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model" :title="title"
                   @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')"
                   :is-loading="loading">
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="is_primary" type="checkbox" :is-switch="true"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="is_released" type="checkbox" :is-switch="true" :hint="true"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input-widget autofocus :model="model" attribute="name"/>
        </div>
      </div>
      <div v-if="showAddressInputs" class="row">
        <div class="col-md-6">
          <country-select-input-widget attribute="country_code" :model="model"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="address"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="address_2"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="address_3"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="state"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="city"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="zip_code"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="email"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="phone"/>
        </div>
      </div>

    </artisio-modal>
  </ValidationObserver>
</template>
<script>
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import ItemLocation from "./ItemLocation.model";
  import CountrySelectInputWidget from "@/core/widgets/CountrySelectInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('setup/branch');

  export default {
    name: "ItemLocationModal",
    components: {CountrySelectInputWidget, InputWidget, ArtisioModal},
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new ItemLocation(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.itemLocationModal,
        parentItemLocation: state => state.itemLocationModal.parentItemLocation,
        editObject: state => state.itemLocationModal.object,
        itemLocations: state => state.itemLocations,
      }),
      showAddressInputs() {
        return true
      },
      title() {
        if (this.parentItemLocation) {
          if (this.model.uuid) {
            return this.$i18n.t(`Update Item Location`);
          }
          return this.$i18n.t("Create New Item Location Under {name}", {name: this.parentItemLocation.name});
        } else if (this.model.uuid) {
          return this.$i18n.t(`Update Item Location`);
        }
        return this.$i18n.t(`Create New Item Location`);
      }
    },
    watch: {
      editObject() {
        if (this.editObject && (this.editObject.uuid || this.editObject.branch_uuid)) {
          this.model = new ItemLocation(this.editObject);
        }
      }
    },
    methods: {
      ...mapActions(['hideItemLocationModal', 'createItemLocation', 'updateItemLocation']),
      findReleasedLocation(excludeUuid = null) {
        const walk = (nodes) => {
          for (const node of nodes || []) {
            if (node.is_released && node.uuid !== excludeUuid) {
              return node;
            }
            const found = walk(node.children);
            if (found) return found;
          }
          return null;
        };
        return walk(this.itemLocations);
      },
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new ItemLocation();
        this.hideItemLocationModal();
      },
      async onSubmit() {
        let response;
        this.loading = true;

        let requestData = this.model.toJSON();
        if (this.parentItemLocation) {
          requestData['parent_uuid'] = this.parentItemLocation.uuid;
        }

        if (requestData.is_released) {
          const previous = this.findReleasedLocation(this.model.uuid || null);
          if (previous && previous.uuid !== this.model.uuid) {
            this.loading = false;
            const confirmed = await this.$confirm(
              this.$i18n.t(
                "Only one location can be set as the Released Location. Saving will move this designation from '{previous}' to '{current}'. Continue?",
                {previous: previous.name, current: this.model.name}
              ),
              null,
              null,
              null,
              this.$i18n.t('Please Confirm'),
              this.$i18n.t('Continue'),
              this.$i18n.t('Cancel'),
            );
            if (!confirmed) {
              return;
            }
            this.loading = true;
          }
        }

        if (!this.model.uuid) {
          response = await this.createItemLocation(requestData);
        } else {
          response = await this.updateItemLocation({requestData});
        }

        this.loading = false;
        if (response.success) {
          this.showConfirmation = false;
          this.hideItemLocationModal();

          if (!this.model.uuid) {
            this.$toast('success', this.$t('Item location was successfully created'));
          } else {
            this.$toast('success', this.$t('Item location was successfully updated'));
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>
